import { typedConfig } from "@/components/ui/gluestack-ui-provider/config";
import { useColorScheme } from "@/components/useColorScheme";

const getColors = (colorScheme: "light" | "dark") => {
  const palette = typedConfig[colorScheme ?? "light"];
  const transformed: typeof palette = {} as any;

  for (const [key, value] of Object.entries(palette)) {
    const k = key as keyof typeof transformed;

    if (value.startsWith("#")) {
      transformed[k] = value;
    } else {
      const split = value.split(" ");
      if (split.length <= 3) {
        transformed[k] = `rgb(${value})`;
      } else {
        transformed[k] = `rgba(${value})`;
      }
    }
  }

  return transformed;
};

const lightPalette = getColors("light");
const darkPalette = getColors("dark");

export function usePalette() {
  const colorScheme = useColorScheme();

  if (colorScheme === "dark") {
    return darkPalette;
  }

  return lightPalette;
}
